/* eslint-disable */
import axios from 'axios'
import config from '@assets/config.json' // api 请求json

// 通用 Module
const state = {}
const mutations = {}
const getters = {}
const actions = {
  // 邮箱判断
  isEmailExist({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/contactperson/IsEmailExist?compId=${
            opt.id
          }&email=${opt.email}`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 信息
  GetAllContactPerson({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/contactperson/GetAllContactPerson?compId=${
            opt.id
          }&email=${opt.email}&type=${opt.type}`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 信息11
  GetAllContactPersonByCompid({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${
            config.api.reqApi
          }/api/contactperson/GetAllContactPersonByCompid?compId=${
            opt.id
          }&exhibitionid=${opt.exhibitionid}`,
          rootState.header
        )
        .then((data) => {
          console.log(data, 1111)
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 人员查询
  GetAllContact({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/contactperson/GetAllContact?compId=${
            opt.id
          }`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  //  保存
  SaveAll({ rootState, commit }, opt) {
    // 直播产品统计导出
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/contactperson/Save`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  }
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
